/* Override default right-aligning of numbers for the port */
.port input[type='number'] {
    text-align: left;
}
